import React from 'react';

import styles from './Steps.module.css'
import {Step} from "./types/Step.interface.ts";
import {Icon} from "../../General/Icon/Icon.tsx";
import {StepStatus} from "./types/StepStatusEnum.ts";
import {cn} from "../../../utils/cn.ts";

interface Props {
    steps: Step[],
    currentStatus: StepStatus,
}

export const Steps: React.FC<Props> = ({steps, currentStatus}) => {
    const isLast = (idx: number) => steps.length - 1 === idx
    const isFinished = (status: StepStatus) => StepStatus.finish === status
    const isWait = (status: StepStatus) => StepStatus.wait === status
    const isProcess = (status: StepStatus) => StepStatus.process === status
    const number = (idx: number) => ++idx

    return (
        <ul className={styles.wrapper}>
            {steps.map(({status, title}, idx) => (
                <li key={title} className={
                    cn(
                      styles.step,
                        (status === currentStatus && isProcess(currentStatus)) && styles.process,
                    )
                }>
                    <div className={styles.mainBlock}>
                        <div
                            data-number={status === currentStatus && isFinished(currentStatus) ? '' : number(idx)}
                            className={cn(
                                styles.icon,
                                (status === currentStatus && (isProcess(currentStatus) || isWait(currentStatus))) && styles.iconProcess,
                                (status === currentStatus && isFinished(currentStatus)) && styles.iconFinished
                            )} />
                        <div className={styles.title}>
                            {title}
                        </div>
                    </div>
                    <div className={styles.angleWait}>
                        {!isLast(idx) && (<>
                            {
                                !(status === currentStatus && (isProcess(currentStatus) || isWait(currentStatus)))
                            ?
                            <Icon name='angle-right--wait' width={9} height={32}/>
                            :
                            <Icon name='angle-right--finish' width={11} height={39} />}
                        </>)}
                    </div>
                </li>
            ))}
        </ul>
    );
};